import { render } from "./Contact.vue?vue&type=template&id=0d588c19"
import script from "./Contact.vue?vue&type=script&lang=js"
export * from "./Contact.vue?vue&type=script&lang=js"

import "./Contact.vue?vue&type=style&index=0&id=0d588c19&lang=scss"

import exportComponent from "C:\\Users\\oscar\\Documents\\GitHub\\ReSeT\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__